import { Ref, forwardRef } from 'react';
import { Input as AntInput, InputProps, InputRef } from 'antd';
import { InputPassword } from 'common/components/antd/Input/InputPassword';
import { TextArea } from 'common/components/antd/Input/TextArea';
import { DataTestIdProxy } from 'common/components/Utilities/DataTestIdProxy';

export type Props = InputProps & { dataTestId?: string };

const InternalInput = forwardRef(({ dataTestId, ...restProps }: Props, ref: Ref<InputRef>) => (
  <DataTestIdProxy dataTestId={dataTestId}>
    <AntInput ref={ref} {...restProps} />
  </DataTestIdProxy>
));

const Input = Object.assign(InternalInput, {
  Password: InputPassword,
  TextArea,
  Search: AntInput.Search,
});

export { Input };
